import { z } from 'zod';
import { validatedGet, validatedPost } from '../api-client.ts';
import { buildExportQuery } from '../utils.ts';
import { StatiniEsitoResult } from './shared.ts';

/** Prefisso API delle righe trasmissibili a Statini. */
export type RisorsaStatini = 'deleghe' | 'deleghe-altri-territori';

/** Le righe di altri territori non hanno bozze: `escluseBozza` manca e vale 0. */
const StatiniAnteprimaResult = z.object({
  daInviare: z.number(),
  escluseBozza: z.number().optional(),
  giaInviate: z.number(),
});

interface StatiniInviaBody {
  filtri: Record<string, string>;
  mese: number;
  anno: number;
}

export const statiniApi = {
  anteprima: (risorsa: RisorsaStatini, filtri: Record<string, string>) =>
    validatedGet(`${risorsa}/statini/anteprima?${buildExportQuery(filtri)}`, StatiniAnteprimaResult),

  invia: (risorsa: RisorsaStatini, body: StatiniInviaBody) =>
    validatedPost(`${risorsa}/statini/invia`, body, StatiniEsitoResult),
};
